module.exports = __webpack_public_path__ + "static/media/prodotti.3d94dd30.jpg";